module.exports = __webpack_public_path__ + "img/preview.1236b083.png";